import { Customer } from "@/types/profile";

/**
 * Tenant/Customer cache — populated by useTenants() hook on app load.
 * Components that need synchronous access to tenant names can use these helpers.
 */
let _cachedTenants: Customer[] = [];

/** Called from useTenants hook to keep the cache in sync */
export function setTenantCache(tenants: Customer[]) {
  _cachedTenants = tenants;
}

/** Get a tenant/customer name by ID */
export const getCustomerName = (customerId: string): string => {
  const tenant = _cachedTenants.find((c) => c.id === customerId);
  return tenant?.name || customerId;
};

/** Map an array of tenant/customer IDs to names */
export const getCustomerNames = (customerIds: string[]): string[] => {
  return customerIds.map((id) => getCustomerName(id));
};

/** Get all cached tenants/customers */
export const getAllCustomers = (): Customer[] => {
  return _cachedTenants;
};
